import { Box, Typography } from "@mui/material";
import { sortFnByKey } from "@notemeal/utils-sort";
import { ExchangeType, Food } from "../../../../types";

interface ExchangeBoxProps {
  foods: Pick<Food, "id" | "name">[];
  name: ExchangeType;
  lastChild: boolean;
}

export const ExchangeBox = ({ foods, name, lastChild }: ExchangeBoxProps) => {

  const maxHeight = foods.length > 5 ? foods.length/2*19 : undefined; // 19px per food item across 2 columns

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8, "&:not(:first-child)": {pt: 3}, pb: lastChild ? 7 : 0 }}>
      <Typography variant="body2Semibold">
        {name[0].toUpperCase()}
        {name.slice(1)}
      </Typography>
      <Box sx={{ display: "flex", flexFlow: "column wrap", overflowX: "hidden", maxHeight }}>
        {foods.sort(sortFnByKey("name")).map(f => (
          <Typography key={f.id} variant="subtitle1" sx={{ width: maxHeight ? "50%" : undefined }}>
            {f.name}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};
